import { Modal, ModalProps } from 'antd';
import { FC } from 'react';

import '../assets/styles/CustomModal.less';

import { classNames } from '../helpers';
import { Close } from './icons';

export interface CustomModalProps extends ModalProps {
    altTitle?: boolean;
}

const CustomModal: FC<CustomModalProps> = ({ altTitle, className, ...props }) => (
    <Modal
        closeIcon={<Close />}
        centered
        {...props}
        className={classNames(
            'custom-modal',
            altTitle && 'alt-title',
            className,
            !props.children && 'no-body',
            !props.title && 'no-title'
        )}
    />
);

export default CustomModal;
